module.exports = __webpack_public_path__ + "assets/img/37_381_big.4f7d70ba.jpg";